import type { VideoFilter } from "@/utils/video";

interface FilterPanelProps {
  genres: string[];
  regions: string[];
  years: number[];
  values: Required<Pick<VideoFilter, "genre" | "region" | "year">>;
  onChange: (key: "genre" | "region" | "year", value: string) => void;
  onReset: () => void;
}

const groupTitle = "mb-2.5 font-label text-[11px] uppercase tracking-[0.16em] text-foreground-500";

const chipClass = (active: boolean) =>
  `whitespace-nowrap rounded px-2.5 py-1.5 text-xs transition-colors ${
    active
      ? "bg-primary-500 text-background-50"
      : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-primary-400"
  }`;

export default function FilterPanel({
  genres,
  regions,
  years,
  values,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-1.5 font-heading text-sm font-medium text-foreground-900">
          <i className="ri-filter-3-line text-base text-primary-400" />
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-[11px] text-foreground-500 transition-colors hover:text-primary-400"
        >
          重置
        </button>
      </div>

      <div className="mt-5 space-y-5">
        <div>
          <p className={groupTitle}>类型</p>
          <div className="flex flex-wrap gap-1.5">
            {["全部", ...genres].map((genre) => (
              <button
                key={genre}
                type="button"
                onClick={() => onChange("genre", genre)}
                className={chipClass(values.genre === genre)}
              >
                {genre}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className={groupTitle}>地区</p>
          <div className="flex flex-wrap gap-1.5">
            {["全部", ...regions].map((region) => (
              <button
                key={region}
                type="button"
                onClick={() => onChange("region", region)}
                className={chipClass(values.region === region)}
              >
                {region}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className={groupTitle}>年份</p>
          <div className="flex flex-wrap gap-1.5">
            {["全部", ...years.map(String)].map((year) => (
              <button
                key={year}
                type="button"
                onClick={() => onChange("year", year)}
                className={chipClass(values.year === year)}
              >
                {year === "全部" ? "全部" : `${year}`}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-5 rounded-md border border-background-200 bg-background-50 p-3">
        <p className="text-[11px] leading-relaxed text-foreground-500">
          <i className="ri-lightbulb-line mr-1 text-primary-400" />
          筛选条件之间为叠加关系，可先选题材再限定年份，快速缩小范围。
        </p>
      </div>
    </div>
  );
}